import { POIFilterType } from 'app/modules/wallforming/components/scenes/objects/pois/types/poiFilterType';

import type { Node } from 'react-checkbox-tree';

export function getPoiFilterData(): Node[] {
    return Object.values(POIFilterType).map(type => ({
        label: type,
        value: type,
    }));
}